import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import RuleStore from '@/store/modules/rule/rule-module';
import Footer from '@/components/Footer/Footer.vue';
import Condition from '@/components/Condition/Condition.vue';
import CompactConditionEditor from '@/components/Condition/CompactConditionEditor.vue';
import draggable from 'vuedraggable';
import router from '@/router';
import { Condition as ConditionType, Rule, Field } from '@/store/modules/rule/rule-types';
import { format } from 'date-fns';
import DateUtils from '@/shared/utils/date-utils';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';
import SimpleVueValidation from 'simple-vue-validator';
import MovementRecordTypeService from '@/services-http/sdi/MovementRecordTypeService';
import NewRules from '@/shared/validators/formRules';
import i18n from '@/plugins/i18n';

const { Validator } = SimpleVueValidation;

@Component({
  components: {
    Footer, Condition, CompactConditionEditor, draggable, PrismEditor,
  },
  validators() {
    return { 'rule.name': (value: string) => Validator.value(value).required(i18n.t('error.ruleNameRequired')) };
  },
})
export default class RuleNew extends Vue {
  @Prop() readonly isEdit!: boolean;

  @Prop() readonly idRule!: number;

  @Prop() readonly copyId!: number;

  kinshipService = new MovementRecordTypeService();

  rule = new Rule();

  newRule = new NewRules();

  search = null;

  menu2 = false;

  date = new Date().toISOString().substr(0, 10);

  movementTypeToggle: number[] = [];

  languageScripts = [
    {
      label: 'Javascript',
      value: '1',
    },
    {
      label: 'Python',
      value: '2',
    },
  ];

  movementRecordColumns: any = [
    {
      label: '',
      value: '',
    },
  ];

  movementRecordTypes = [
    {
      id: 0,
      name: '',
      description: '',
      code: '',
    },
  ];

  movementRecordTypesAux = [
    {
      id: 0,
      name: '',
      description: '',
      code: '',
    },
  ];

  movementRecordTypesSelecteds = [
    {
      id: 0,
      name: '',
      description: '',
      code: '',
    },
  ];

  addButtonDisabled = true;

  removeButtonDisabled = true;

  movementRecordTypeIndexToAdd = [];

  movementRecordTypeIndexToRemove = [];

  loadingMovementRecordColumns = true;

  conditionLayout: 'compact' | 'classic' = 'compact';

  typeIndex = 0;

  typeCodes = ['QUERY', 'SCRIPT', 'GROOVY'];

  conditionLayoutOptions = [
    { label: 'Blocos compactos', value: 'compact' },
    { label: 'Clássico', value: 'classic' },
  ];

  @Watch('movementRecordTypeIndexToAdd', { immediate: true, deep: true })
  onSelectToAdd(array: any) {
    if (array.length) {
      this.addButtonDisabled = false;
    } else {
      this.addButtonDisabled = true;
    }
    this.removeButtonDisabled = true;
  }

  @Watch('movementRecordTypeIndexToRemove', { immediate: true, deep: true })
  onSelectToRemove(array: any) {
    if (array.length) {
      this.removeButtonDisabled = false;
    } else {
      this.removeButtonDisabled = true;
    }
    this.addButtonDisabled = true;
  }

  @Watch('typeIndex')
  onTypeIndexChange() {
    this.rule.type = this.typeCodes[this.typeIndex];
  }

  clearAdd() {
    this.movementRecordTypeIndexToAdd = [];
  }

  clearRemove() {
    this.movementRecordTypeIndexToRemove = [];
  }

  addSelecteds() {
    if (this.movementRecordTypeIndexToAdd.length) {
      this.movementRecordTypeIndexToAdd.forEach((index) => {
        const item = this.movementRecordTypes[index];
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.movementRecordTypesSelecteds.push(item);
      });

      this.movementRecordTypeIndexToAdd.sort().reverse();
      this.movementRecordTypeIndexToAdd.forEach((index) => {
        this.movementRecordTypes.splice(index, 1);
      });

      this.movementRecordTypes.sort((a, b) => (a.name > b.name ? 1 : -1));
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.movementRecordTypesSelecteds.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.movementRecordTypeIndexToAdd = [];
      this.verifyIfEnabled();
    }
  }

  removeSelecteds() {
    if (this.movementRecordTypeIndexToRemove.length) {
      this.movementRecordTypeIndexToRemove.forEach((index) => {
        const item = this.movementRecordTypesSelecteds[index];
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.movementRecordTypes.push(item);
      });

      this.movementRecordTypeIndexToRemove.sort().reverse();
      this.movementRecordTypeIndexToRemove.forEach((index) => {
        this.movementRecordTypesSelecteds.splice(index, 1);
      });

      this.movementRecordTypesSelecteds.sort((a, b) => (a.name > b.name ? 1 : -1));
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.movementRecordTypes.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.movementRecordTypeIndexToRemove = [];
      this.verifyIfEnabled();
    }
  }

  criticismInRule() {
    return 'criticismId' in this.rule;
  }

  verifyIfEnabled() {
    if (!this.movementRecordTypes.length) {
      this.addButtonDisabled = true;
    } else {
      this.addButtonDisabled = false;
    }

    if (!this.movementRecordTypesSelecteds.length) {
      this.removeButtonDisabled = true;
    } else {
      this.removeButtonDisabled = true;
    }
  }

  loadMovementRecordColumns() {
    this.movementRecordColumns = [];
    const ds = this.currentDatasource;
    if (ds && ds.length) {
      this.movementRecordColumns = ds[0].columns;
    }

    this.loadingMovementRecordColumns = false;
  }

  async loadMovementTypes() {
    this.movementRecordTypes = [];
    this.movementRecordTypesAux = [];
    this.movementRecordTypesSelecteds = [];
    await this.kinshipService.FindAll().then((response) => {
      if (response && response.data && response.data.length) {
        this.movementRecordTypesAux = response.data;
        this.movementRecordTypesAux.sort((a, b) => (a.name > b.name ? 1 : -1));
      }
    });
  }

  loadMovementTypesFromRule() {
    const typeMap: Record<string, number> = { EXPRESSION: 0, QUERY: 0, SCRIPT: 1, GROOVY: 2 };
    this.typeIndex = typeMap[this.rule.type] ?? 0;

    if (this.isStatementDomain) {
      this.rule.type = 'EXPRESSION';
      this.typeIndex = 0;
      return;
    }

    const allMovementsTypes = this.movementRecordTypesAux;
    const movementTypesFromRule = this.rule.movementTypes;

    this.movementRecordTypesSelecteds = this.rule.movementTypes;

    if (allMovementsTypes.length && movementTypesFromRule.length) {
      const elementsDifferents = allMovementsTypes.filter((item1) => !movementTypesFromRule.some((item2) => item1.id === item2.id));

      this.movementRecordTypesAux = elementsDifferents;
      this.movementRecordTypes = this.movementRecordTypesAux;
    } else {
      this.movementRecordTypes = this.movementRecordTypesAux;
    }
  }

  code = '\n\n\n\n\n\n\n';

  loading = false;

  async mounted() {
    this.$validate();
    await this.loadMovementTypes();
    this.conditionLayout = 'compact';

    if (this.isEdit || this.copyId) {
      await RuleStore.findRuleById(this.idRule || this.copyId);
      Vue.set(this, 'rule', RuleStore.rule);
      this.loadMovementTypesFromRule();
    } else {
      this.movementRecordTypes = this.movementRecordTypesAux;
      const initialCondition = new ConditionType();
      initialCondition.order = 1;
      initialCondition.fields = [new Field(1), new Field(2)];
      Vue.set(this.rule, 'conditions', [initialCondition]);
    }

    await Promise.all<any>([
      RuleStore.getConditionTypes(),
      RuleStore.getDatasources(),
      RuleStore.getFieldTypes(),
      RuleStore.getFieldFunctions(),
      RuleStore.getFieldConstants(),
      RuleStore.getOperators(),
      RuleStore.getDefaultValueDescriptions(),
      RuleStore.getRuleTags(),
      RuleStore.getCriticism(),
      RuleStore.getDomains(),
    ]);

    this.prepareToggleMovementType();
    this.loadMovementRecordColumns();

    if (!this.rule.script) {
      this.rule.script = this.code;
    }
  }

  @Watch('conditionLayout')
  onConditionLayoutChange(val: string) {
    localStorage.setItem('conditionLayout', val);
  }

  get ruleIndex() {
    return RuleStore.ruleIndex || false;
  }

  get ruleTags() {
    return RuleStore.ruleTags;
  }

  get ruleFieldTypes() {
    return RuleStore.fieldTypes.filter((field) => field.showOnDefaultValue);
  }

  get defaultValueDescriptions() {
    return RuleStore.defaultValueDescriptions;
  }

  get criticism() {
    return RuleStore.ruleCriticism;
  }

  get domains() {
    return RuleStore.ruleDomains;
  }

  get fieldTypes() {
    return RuleStore.ruleFieldTypes;
  }

  get fieldFunctions() {
    return RuleStore.fieldFunctions;
  }

  get constants() {
    return RuleStore.fieldConstants;
  }

  get operators() {
    return RuleStore.operators;
  }

  get ruleNameRequired() {
    return this.$t('error.ruleNameRequired');
  }

  getcomputedDateFormatted() {
    if (this.rule?.defaultValue) {
      return format(DateUtils.normalizedDate(this.rule?.defaultValue!), 'dd/MM/yyyy');
    }
    return null;
  }

  getError(fieldName: string) {
    return this.validation.isTouched(fieldName) ? this.validation.firstError(fieldName) : [];
  }

  get dataSourceForCondition() {
    return this.currentDatasource;
  }

  get isMovementDomain(): boolean {
    return !this.rule.domain || this.rule.domain === 'MOVEMENT';
  }

  get isStatementDomain(): boolean {
    return this.rule.domain === 'STATEMENT';
  }

  get conditionTypes() {
    return RuleStore.conditionTypes;
  }

  get datasource() {
    return RuleStore.datasource;
  }

  get currentDatasource() {
    const all = RuleStore.datasource;
    return this.isStatementDomain
      ? all.filter((ds) => ds.value === 'coparticipation')
      : all.filter((ds) => ds.value !== 'coparticipation');
  }

  get conditionTypeOptions() {
    return RuleStore.conditionTypes.filter((ct: string) => ct);
  }

  back() {
    router.push('/rule');
  }

  cancel() {
    router.push('/home-all-menus');
  }

  async save() {
    if ((this.$refs.formNames as Vue & { validate: () => boolean }).validate()) {
      try {
        this.loading = true;
        this.sanitizeData();
        this.rule.origin = 'GENERAL_RULE';

        if (this.isStatementDomain) {
          this.rule.movementTypes = [];
        } else {
          this.rule.movementTypes = this.movementRecordTypesSelecteds;
        }

        if (this.copyId) {
          const { id, idRule, ...rule } = this.rule;
          await RuleStore.saveRule(rule);
        } else {
          await RuleStore.saveRule(this.rule);
        }
      } catch (error) {
        Vue.toasted.global.customError('Ocorreu um erro ao processar sua requisição, '
          + 'tente novamente mais tarde.');
      } finally {
        this.loading = false;
      }
    }
  }

  sanitizeData() {
    if (this.rule.type === 'SCRIPT') {
      this.rule.conditions = [];
    } else if (this.rule.type === 'GROOVY') {
      this.rule.conditions = [];
      this.rule.scriptLanguage = '';
    } else {
      this.rule.script = '';
      this.rule.scriptLanguage = '';
    }
  }

  async onDomainChange(domain: string) {
    this.movementRecordTypesSelecteds = [];

    if (domain === 'MOVEMENT') {
      this.movementRecordTypes = [...this.movementRecordTypesAux];
      this.rule.dataSource = 'registro_movimentacao';
      if (this.rule.conditions) {
        this.rule.conditions.forEach((c) => {
          c.dataSource = 'registro_movimentacao';
        });
      }
    }

    if (domain === 'STATEMENT') {
      this.rule.type = 'EXPRESSION';
      this.typeIndex = 0;
      this.rule.dataSource = 'coparticipation';
      if (this.rule.conditions) {
        this.rule.conditions.forEach((c) => {
          c.dataSource = 'coparticipation';
        });
      }
    }

    if (domain) {
      await Promise.all([RuleStore.getDatasources(), RuleStore.getDomainFields(domain)]);
    }
  }

  reorderConditions(conditions: ConditionType[]) {
    conditions.forEach((condition, index) => {
      if (this.isMovementDomain || index === 0) {
        condition.type = 'AND';
      }
      condition.order = index + 1;
    });
  }

  getNextConditionId(conditions: ConditionType[]) {
    if (!conditions.length) return 1;
    return Math.max(...conditions.map((c) => c.id || 0)) + 1;
  }

  addCondition() {
    const condition = new ConditionType();
    condition.id = this.getNextConditionId(this.rule.conditions);
    condition.order = this.rule.conditions.length + 1;
    condition.fields = [new Field(1), new Field(2)];
    const conditions = this.rule.conditions
      || Vue.set<ConditionType[]>(this.rule, 'conditions', []);
    conditions.push(condition);
  }

  removeCondition(conditionId: number) {
    const newConditionList = this.rule.conditions
      .filter((condition) => condition.id !== conditionId);
    this.reorderConditions(newConditionList);
    Vue.set(this.rule, 'conditions', newConditionList);
  }

  setMovementType(movementFieldName: 'implantation' | 'inclusion' | 'exclusion' | 'alteration') {
    this.rule[movementFieldName] = !this.rule[movementFieldName];
  }

  prepareToggleMovementType() {
    // eslint-disable-next-line no-unused-expressions
    this.rule.implantation ? this.movementTypeToggle.push(0) : null;
    // eslint-disable-next-line no-unused-expressions
    this.rule.inclusion ? this.movementTypeToggle.push(1) : null;
    // eslint-disable-next-line no-unused-expressions
    this.rule.exclusion ? this.movementTypeToggle.push(2) : null;
    // eslint-disable-next-line no-unused-expressions
    this.rule.alteration ? this.movementTypeToggle.push(3) : null;
  }

  setDefaultTypeDate(selectedDate: string) {
    this.rule.defaultValue = selectedDate;
  }

  clearDefaultTypeValue() {
    this.rule.defaultValue = '';
  }

  highlighter(code: string) {
    return highlight(code, languages.js);
  }
}
